import { Box, Button, Select } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const ProfileAlertButtonsWrapper = styled('div')`
  display: flex;
  border-radius: 25px;
  border: 1px solid;
  height: 36px;
  margin-right: 10px;
  align-items: center;
  width: 70px;
  justify-content: center;
  border-color: ${colors.primary};
  flex: ${({ stretch }: { stretch: boolean }) => (stretch ? 1 : 'none')};
  overflow: hidden;
  box-shadow: 2px 4px 2px 0px #2c607b26;
`

export const FrequencySelect = styled(Select)`
  width: 100%;
`

export const ProfileAlertPopoverWrapper = styled(Box)`
  width: 250px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const EditAlertButtonWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`

export const IconWrapper = styled('span')`
  display: inline-flex;
  background-color: ${({ $hasBackground, $hovered }: { $hasBackground: boolean; $hovered: boolean }) =>
    $hasBackground ? colors.primary : ($hovered && colors.headerBg) || colors.white};
  flex: 1;
  height: 100%;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${({ $hasBackground }: { $hasBackground: boolean }) => ($hasBackground ? colors.primary : colors.headerBg)};
  }

  &:first-child {
    padding-left: 4px;
  }

  &:last-child {
    padding-right: 4px;
  }
`

export const StyledProfileAlertButton = styled(Button)`
  padding: 6px 13px 7px 13px;
  min-height: unset;
`
